import { JobStatsServicePromiseClient } from '@taxfyle/api-internal/internal/job_stats_grpc_web_pb'
import {
  GetJobTotalPriceAggregationsRequest,
  GetJobTotalsRequest,
  GetJobTotalStatusAggregationsRequest,
  ListProOpenJobCountsRequest,
} from '@taxfyle/api-internal/internal/job_stats_pb'

import { createGrpcAuthenticator } from 'infra/grpc-authenticator'
import { memoize } from 'lodash'
import { APIConfig } from 'types/definitions'
import { enableDevTools } from 'utils/grpc-util'

export function createJobStatsAPI(config: APIConfig) {
  return new JobStatsAPI(config)
}

export class JobStatsAPI {
  private readonly jobStatsGrpcClient = createJobStatsGrpcClient(
    this.workDotnetConfig.baseURL,
  )

  private readonly grpcAuthenticator = createGrpcAuthenticator(
    this.workDotnetConfig,
  )

  constructor(private workDotnetConfig: APIConfig) {}

  async listProOpenJobCounts(request: ListProOpenJobCountsRequest) {
    return this.jobStatsGrpcClient.listProOpenJobCounts(
      request,
      await this.grpcAuthenticator.getMeta(),
    )
  }

  async getJobTotalPriceAggregations(
    request: GetJobTotalPriceAggregationsRequest,
  ) {
    return this.jobStatsGrpcClient.getJobTotalPriceAggregations(
      request,
      await this.grpcAuthenticator.getMeta(),
    )
  }

  async getJobTotals(request: GetJobTotalsRequest) {
    return this.jobStatsGrpcClient.getJobTotals(
      request,
      await this.grpcAuthenticator.getMeta(),
    )
  }

  async getJobTotalStatusAggregations(
    request: GetJobTotalStatusAggregationsRequest,
  ) {
    return this.jobStatsGrpcClient.getJobTotalStatusAggregations(
      request,
      await this.grpcAuthenticator.getMeta(),
    )
  }
}

/**
 * Creates an job stats dotnet client that is memoized.
 */
const createJobStatsGrpcClient = memoize(function createJobGrpcClient(
  baseUrl: string,
) {
  const client = new JobStatsServicePromiseClient(baseUrl)
  enableDevTools(client)
  return client
})
